import { baseApi } from '../baseApi';
import {
  transformAccountLimits,
  transformAccountCredits,
  transformPurchaseHistory,
  transformUserInfo,
} from './transformers';
import {
  AccountCredits,
  AccountLimits,
  AppResponse,
  AppsResponse,
  PurchaseHistory,
  UserInfo,
} from './types';

const userApi = baseApi.injectEndpoints({
  endpoints: (build) => ({
    getUserInfo: build.query<UserInfo, void>({
      query: () => ({
        url: '/users/me',
      }),
      transformResponse: transformUserInfo,
    }),
    getUserApps: build.query<AppsResponse, void>({
      query: () => ({
        url: '/apps',
      }),
      providesTags: ['Apps'],
    }),
    createApp: build.mutation<AppResponse, FormData>({
      query: (formData) => ({
        url: '/apps',
        method: 'POST',
        body: formData,
      }),
      invalidatesTags: ['Apps'],
    }),
    getAccountLimits: build.query<AccountLimits, { apiKey: string }>({
      query: ({ apiKey }) => ({
        url: '/api/account/limits',
        method: 'GET',
        headers: {
          'Api-Key': apiKey,
        },
      }),
      transformResponse: transformAccountLimits,
      keepUnusedDataFor: 0,
    }),
    getPurchaseHistory: build.query<PurchaseHistory, void>({
      query: () => ({
        url: '/top-ups?include_api=true',
      }),
      transformResponse: transformPurchaseHistory,
    }),
    getAccountCredits: build.query<AccountCredits, { apiKey: string }>({
      query: ({ apiKey }) => ({
        url: '/api/account/credits',
        method: 'GET',
        headers: {
          'Api-Key': apiKey,
        },
      }),
      transformResponse: transformAccountCredits,
      keepUnusedDataFor: 0,
    }),
  }),
});

export default userApi;
